import WebApi from '@/views/loyalty/shared/modules/web_api'
import { unwrapEnvelope, buildQuery } from '@/views/skud/shared/modules/skud-http'

export class SkudReportEndpoint {
  constructor () {
    this.url = `${process.env.VUE_APP_CHARON_URL}api/management/`
    this.webApi = new WebApi()
  }

  // placeId не задан -> client-scope GET /reports/...
  seg (placeId) {
    return placeId ? `places/${placeId}/` : ''
  }

  // params: from, to, group_ref, dimension (by_day/by_group/top_subjects)
  async getLatecomers (placeId, params) {
    const res = await this.webApi.get(`${this.url}${this.seg(placeId)}reports/latecomers?${buildQuery(params)}`)
    return unwrapEnvelope(res)
  }

  // params: from, to, group_ref, limit
  async getEarlyLeavers (placeId, params) {
    const res = await this.webApi.get(`${this.url}${this.seg(placeId)}reports/early_leavers?${buildQuery(params)}`)
    return unwrapEnvelope(res)
  }

  // params: from, to, group_ref, limit
  async getSuspicious (placeId, params) {
    const res = await this.webApi.get(`${this.url}${this.seg(placeId)}reports/suspicious?${buildQuery(params)}`)
    return unwrapEnvelope(res)
  }
}
